import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import {
    donorSupportCategoriesWithDonationInput,
    donorSupportCategoriesWithGiftCodeInput,
    donorSupportCategoriesWithGiftCodeInputs,
    donorSupportCategoriesWithoutMessageInput,
    donorSupportCategoriesWithPartnershipsInput,
    donorSupportCategoriesWithProjectInput,
    donorSupportCategoriesWithPromoCodeInput,
    donorSupportCategoriesWithReferrerSelectInput,
} from './contactConstants.js';
import { PartnershipFields } from './PartnershipFields.js';
import CategorySelectors from './CategorySelectors.js';
import DynamicGiftCodeInputList from './DynamicGiftCodeInputList.js';
import { parseDate } from '../common/timeUtil.js';
import { projectFormatter } from '../common/projectFormatter.js';

const MaybeError = ({ errorText }) => {
    if (errorText == null) {
        return null;
    } else {
        return <div className="error-text">{errorText}</div>;
    }
};
MaybeError.propTypes = {
    errorText: PropTypes.string,
};

export const DonorContactForm = createReactClass({
    propTypes: {
        formData: PropTypes.object.isRequired,
        supportCategories: PropTypes.object.isRequired,
        tierSelectedSupportCategories: PropTypes.object,
        formErrors: PropTypes.object.isRequired,
        loggedInUser: PropTypes.bool,
        fieldsEnabledForEdits: PropTypes.array.isRequired,
        chosenSupportCategory: PropTypes.object.isRequired,
        donationInfo: PropTypes.array,
        callbacks: PropTypes.object.isRequired,
    },

    displayFAQ() {
        if (this.props.chosenSupportCategory.faq) {
            return (
                <div className="support-faq-container">
                    <div className="supportFaq" dangerouslySetInnerHTML={{ __html: this.props.chosenSupportCategory.faq }}/>
                </div>
            );
        }
    },

    renderFullNameField() {
        if (this.props.loggedInUser && this.props.fieldsEnabledForEdits.indexOf('fullName') === -1 && !this.props.formErrors.fullName) {
            return (
                <div className="input-holder prepopulated">
                    <label htmlFor="fullName">Full name</label>
                    <div className="input-display">
                        {this.props.formData.fullName}
                        <a name="fullName" id="fullName" tabIndex={0} role="presentation" onKeyDown={(event) => {
                            // this handler accompanying onClick for accessibility
                            if (event.key === 'Enter' || event.keyCode === 13) {
                                this.props.callbacks.enablePrepopulatedFieldEdit(event);
                            }
                        }} onClick={this.props.callbacks.enablePrepopulatedFieldEdit}>change</a>
                        <input type="hidden" name="fullName" value={this.props.formData.fullName}/>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="input-holder">
                    <label htmlFor="fullName">Full name</label>
                    <input type="text" name="fullName" id="fullName" className={this.props.formErrors.fullName ? 'hasError' : ''} value={this.props.formData.fullName} onChange={this.props.callbacks.handleInputChange} />
                    {this.props.formErrors.fullName ? (<div className="error-text">{this.props.formErrors.fullName}</div>) : null}
                </div>
            );
        }
    },

    renderEmailField() {
        if (this.props.loggedInUser && this.props.fieldsEnabledForEdits.indexOf('email') === -1 && !this.props.formErrors.email) {
            return (
                <div className="input-holder prepopulated">
                    <label htmlFor="email">Email address</label>
                    <div className="input-display">
                        {this.props.formData.email}
                        <a name="email" tabIndex={0} role="presentation" onKeyDown={(event) => {
                            // this handler accompanying onClick for accessibility
                            if (event.key === 'Enter' || event.keyCode === 13) {
                                this.props.callbacks.enablePrepopulatedFieldEdit(event);
                            }
                        }} onClick={this.props.callbacks.enablePrepopulatedFieldEdit}>change</a>
                        <input type="hidden" name="email" value={this.props.formData.email}/>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="input-holder">
                    <label htmlFor="email">Email address</label>
                    <input type="email" name="email" id="email" className={this.props.formErrors.email ? 'hasError' : ''} value={this.props.formData.email} onBlur={this.props.callbacks.findUserByUserName} onChange={this.props.callbacks.handleInputChange}/>
                    {this.props.formErrors.email ? (<div className="error-text">{this.props.formErrors.email}</div>) : null}
                </div>
            );
        }
    },

    renderUserInfoFields() {
        return (
            <div>
                {this.renderEmailField()}
                {this.renderFullNameField()}
                <input type="hidden" name="userId" value={this.props.formData.userId}/>
                {!donorSupportCategoriesWithGiftCodeInputs[this.props.chosenSupportCategory.keyword] &&
                    <div className="input-holder">
                        <label htmlFor="phone">Phone number (optional)</label>
                        <input type="text" name="phone" id="phone" className="phone-number"
                            value={this.props.formData.phone} onChange={this.props.callbacks.handleInputChange}/>
                    </div>
                }
            </div>
        );
    },

    renderPromoCodeField() {
        if (donorSupportCategoriesWithPromoCodeInput[this.props.chosenSupportCategory.keyword]) {
            return (
                <div className="input-holder">
                    <label htmlFor="promoCode">Promo code {this.props.chosenSupportCategory.keyword === 'donor-promo-forgot' ? '' : ' (optional)'}</label>
                    <input type="text" name="promoCode" id="promoCode" className={this.props.formErrors.promoCode ? 'hasError' : ''} value={this.props.formData.promoCode} onChange={this.props.callbacks.handleInputChange}/>
                    {this.props.formErrors.promoCode ? (<div className="error-text">{this.props.formErrors.promoCode}</div>) : null}
                </div>
            );
        }
    },

    renderGiftCodeField() {
        if (donorSupportCategoriesWithGiftCodeInput[this.props.chosenSupportCategory.keyword]) {
            return (
                <div className="input-holder">
                    <label htmlFor="giftCode">Gift code (optional)</label>
                    <input type="text" name="giftCode" id="giftCode" value={this.props.formData.giftCode} onChange={this.props.callbacks.handleInputChange}/>
                </div>
            );
        }
    },

    renderGiftCodeFields() {
        if (donorSupportCategoriesWithGiftCodeInputs[this.props.chosenSupportCategory.keyword]) {
            return (
                <div>
                    <DynamicGiftCodeInputList handleGiftCodesChange={this.props.callbacks.handleGiftCodesChange}
                        giftCodes={this.props.formData.giftCodes}
                        addGiftCodeCallback={this.props.callbacks.addGiftCodeCallback}
                        removeGiftCodeCallback={this.props.callbacks.removeGiftCodeCallback} />
                </div>
            );
        }
    },

    renderDonationAndProjectFields() {
        if (donorSupportCategoriesWithDonationInput[this.props.chosenSupportCategory.keyword]) {
            if (this.props.loggedInUser && this.props.donationInfo.length > 0) {
                var options = this.props.donationInfo.map(function (donation) {
                    var parsedDate = parseDate(donation.date);
                    return <option key={donation.id}
								   value={donation.id}>{donation.projectTitle} - {projectFormatter.formatCurrency(donation.amount)} on {parsedDate.getMonthName() + ' ' + parsedDate.getDate() + ', ' + parsedDate.getFullYear()}</option>;
                }, this);

                return (
                    <div className="input-holder">
                        <label htmlFor="donationId">Past
								donation {this.props.chosenSupportCategory.keyword === 'donor-promo-forgot' ? '' : ' (optional)'}</label>
                        <select className={this.props.formErrors.donationId ? 'hasError' : ''}
                            name="donationId" id="donationId" value={this.props.formData.donationId}
                            onChange={this.props.callbacks.handleInputChange}>
                            <option value="">Select one</option>
                            {options}
                        </select>
                        {this.props.formErrors.donationId ? (
                            <div className="error-text">{this.props.formErrors.donationId}</div>) : null}
                    </div>
                );
            } else if (this.props.chosenSupportCategory.keyword === 'donor-promo-forgot') {
                // Special handling for retromatch requests: if they don't have donations,
                // show a *non-optional* text field with different label.
                // (Keep name/ID the same, though - serverside handling is unchanged.)
                return (
                    <div className="input-holder" id="project-field">
                        <label htmlFor="projectTitle">Project title or donation ID</label>
                        <input type="text" name="projectTitle" id="projectTitle" value={this.props.formData.projectTitle} onChange={this.props.callbacks.handleInputChange}/>
                        <MaybeError errorText={this.props.formErrors.projectTitle} />
                    </div>
                );
            } else {
                return (
                    <div className="input-holder" id="project-field">
                        <label htmlFor="projectTitle">Project title (optional)</label>
                        <input type="text" name="projectTitle" id="projectTitle" value={this.props.formData.projectTitle} onChange={this.props.callbacks.handleInputChange}/>
                    </div>
                );
            }
        } else {
            if (donorSupportCategoriesWithProjectInput[this.props.chosenSupportCategory.keyword]) {
                return (
                    <div className="input-holder" id="project-field">
                        <label htmlFor="projectTitle">Project title (optional)</label>
                        <input type="text" name="projectTitle" id="projectTitle" value={this.props.formData.projectTitle} onChange={this.props.callbacks.handleInputChange}/>
                    </div>
                );
            }
        }
    },

    renderPartnershipFields() {
        if (donorSupportCategoriesWithPartnershipsInput[this.props.chosenSupportCategory.keyword]) {
            return (
                <div className="input-holder">
                    <PartnershipFields
                        formErrors={this.props.formErrors}
                        chosenSupportCategory = {this.props.chosenSupportCategory}
                        organizationName = {this.props.formData.organizationName}
                        partnerReferrer = {this.props.formData.partnerReferrer}
                        wordOfMouthReferrer = {this.props.formData.wordOfMouthReferrer}
                        handleInputChange = {this.props.callbacks.handleInputChange}
                        handlePartnerReferrerChange = {this.props.callbacks.handlePartnerReferrerChange}
                    />
                </div>
            );
        }
    },

    renderMessageField() {
        if (!(donorSupportCategoriesWithoutMessageInput[this.props.chosenSupportCategory.keyword])) {
            return (
                <div className="input-holder" id="donor-contact-message-holder">
                    <label htmlFor="message">How can we help?</label>
                    <textarea name="message" id="message" className={this.props.formErrors.message ? 'hasError' : ''} value={this.props.formData.message} onChange={this.props.callbacks.handleInputChange}/>
                    {this.props.formErrors.message ? (<div className="error-text">{this.props.formErrors.message}</div>) : null}
                </div>
            );
        }
    },

    renderPartnershipsMessage() {
        if (donorSupportCategoriesWithReferrerSelectInput[this.props.chosenSupportCategory.keyword]) {
            return (
                <div className="support-faq-container-partnership">
                    <div className="supportFaq">Please share any ideas or examples of what you'd like to accomplish by partnering with us. This might include building your brand, raising awareness around a classroom product, engaging employees, targeting education outcomes, or creating local impact.</div>
                </div>
            );
        }
    },

    trackSubmit() {
        if (dcAnalytics) {
            dcAnalytics.trackHelpCenter([pageName, 'donor', 'click submit']);
            dcAnalytics.track('Contact form', {
                formType: 'donor',
                formAction: 'click submit',
            });
        }
    },

    render() {
        return (
            <form id="donorContactForm" name="contactForm" className="form-redux" method="POST" onSubmit={this.props.callbacks.handleFormSubmit} action={secureBaseURL + 'help/donor_contact_form.html'}>
                <input type="hidden" id="supportCategoryId" name="supportCategoryId" value={this.props.formData.supportCategoryId}/>
                <CategorySelectors
                    supportCategories = {this.props.supportCategories}
                    tierSelectedSupportCategories = {this.props.tierSelectedSupportCategories}
                    formErrors={this.props.formErrors}
                    callbacks={this.props.callbacks}
                />
                {this.displayFAQ()}
                {this.renderUserInfoFields()}
                {this.renderGiftCodeField()}
                {this.renderPromoCodeField()}
                {this.renderDonationAndProjectFields()}
                {this.renderPartnershipFields()}
                {this.renderMessageField()}
                {this.renderPartnershipsMessage()}
                {this.renderGiftCodeFields()}
                <input type="submit" className="button-primary" value="Submit question" onClick={this.trackSubmit} />
            </form>
        );
    },
});
